/**
 *  Enum trạng thái khôi phục dữ liệu
 */
export default {
  /**
   * Đang restore
   */
  Restoring: 1,

  /**
   * Restore thành công
   */
  RestoreSuccess: 2,

  /**
   * Bị dừng bời người dùng
   */
  RestoreCancel: 3,

  /**
   * Restore thất bại
   */
  RestoreError: 4,
};
